import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=50b7f078&scoped=true"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=50b7f078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b7f078",
  null
  
)

export default component.exports